module.exports = __webpack_public_path__ + "static/media/bookstore-phone.1e2eefd3.png";